module.exports = __webpack_public_path__ + "static/media/05_gazetaesporte.831916aa.jpg";